import StepBaseService from "../stepBase";
import CompleteStepBusinessType from "./completeStepBusinessType";

const settingKeyToStepIdMap = {
  [CompleteStepBusinessType.supportingFile.settingKey]: "supportingFileProcedureStepId",
  [CompleteStepBusinessType.procedureOwner.settingKey]: "poProcedureStepId",
  [CompleteStepBusinessType.primaryProcedureOwner.settingKey]: "ppoProcedureStepId",
  [CompleteStepBusinessType.jBStatus.settingKey]: "jbStatusProcedureStepId",
  [CompleteStepBusinessType.pmpExcluded.settingKey]: "pmpExcludedProcedureStepId",
  [CompleteStepBusinessType.tLReview.settingKey]: "tlReviewProcedureStepId",
  [CompleteStepBusinessType.signOff.settingKey]: "signOffProcedureStepId",
};

class StepService extends StepBaseService {
  completedPageNewStepId = {
    supportingFileProcedureStepId: null,
    procedureFileProcedureStepId: null,
    ppoProcedureStepId: null,
    poProcedureStepId: null,
    pmpExcludedProcedureStepId: null,
    jbStatusProcedureStepId: null,
    signOffProcedureStepId: null,
    tlReviewProcedureStepId: null,
  };

  pageParams = {
    isHistorical: false,
    isShareTaskProcess: false,
    procedureStepId: "",
    procedureTaskId: "",
  };

  /**
   * Sets the step interface merge payload
   * @param {Object} flowDataResponse - The flow data response object
   * @param {Object} [overrideParams] - Optional override parameters
   * @param {boolean} [overrideParams.isHistorical] - Indicates if the data is historical
   * @param {boolean} [overrideParams.isShareTaskProcess] - Indicates if it is a shared task process
   * @param {string} [overrideParams.procedureStepId] - The procedure step ID
   * @param {string} [overrideParams.procedureTaskId] - The procedure task ID
   */
  setStepInterfaceMergePayload = (flowDataResponse: any, overrideParams: any) => {
    // @ts-ignore
    this.completedPageNewStepId = Object.values(settingKeyToStepIdMap).reduce((acc, key) => {
      if (key in flowDataResponse) {
        // @ts-ignore
        acc[key] = flowDataResponse[key];
      }
      return acc;
    }, {});
    if (overrideParams) {
      this.pageParams = overrideParams;
    }
  };

  /**
   * Gets the merge payload by setting key
   * @param {Array<string>} settingKeyList - The list of setting keys
   * @returns {Object} The merge payload object
   */
  getMergePayloadBySettingKey = (settingKeyList: any) => {
    return settingKeyList.reduce((acc: any, key: any) => {
      if (settingKeyToStepIdMap[key]) {
        if (!this.pageParams.isHistorical) {
          return acc;
        }
        acc[key] = {
          ProcedureStepID:
            // @ts-ignore
            this.completedPageNewStepId[settingKeyToStepIdMap[key]],
        };
      } else {
        // taskInfo/shareTask/procedureFile go this branch
        const map = {
          [CompleteStepBusinessType.taskInfo.settingKey]: {
            procedureStepId: this.pageParams.procedureStepId,
            procedureTaskId: this.pageParams.procedureTaskId,
            isHistorical: this.pageParams.isHistorical,
            isOverRide: true,
          },
          [CompleteStepBusinessType.shareTask.settingKey]: {
            isHistorical: this.pageParams.isHistorical,
            isShareTaskProcess: this.pageParams.isShareTaskProcess,
            isOverRide: false,
          },
          [CompleteStepBusinessType.procedureFile.settingKey]: {
            ProcedureStepID: this.pageParams.procedureStepId,
            isOverRide: false,
          },
        };
        acc[key] = map[key];
      }

      return acc;
    }, {});
  };
}

export default new StepService();
